import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const UnderlineIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Underline",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M6.99 29.99h18.28c.83-.07 1.48-.77 1.48-1.61s-.65-1.54-1.47-1.61H6.86c-.89 0-1.62.72-1.62 1.62s.72 1.62 1.62 1.62H7Zm9.14-5.38c5.51 0 9.67-4.49 9.67-10.44V3.48C25.73 2.65 25.03 2 24.19 2s-1.54.65-1.61 1.47v10.7c0 4.18-2.71 7.21-6.45 7.21s-6.45-3.11-6.45-7.2V3.48C9.61 2.65 8.91 2 8.07 2s-1.54.65-1.61 1.47v10.7c-.01 5.95 4.16 10.44 9.67 10.44"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M16.29 24.05c-4.1 0-7.43-3.33-7.43-7.43V3a1.14 1.14 0 1 1 2.28 0v13.62c0 2.83 2.31 5.14 5.15 5.14s5.15-2.31 5.15-5.14V3a1.14 1.14 0 1 1 2.28 0v13.62c0 4.1-3.33 7.43-7.43 7.43M26.57 29.29H6a1.14 1.14 0 1 1 0-2.28h20.57a1.14 1.14 0 1 1 0 2.28"
      })
    })
  }));
};
UnderlineIcon.displayName = 'UnderlineIcon';